import * as actions from "./actionsTypes";

const initialData = {
  loaderEvalFormCompetencyQuestion: false,
  evalFormCompetencyQuestion: null,
  evalFormCompetencyQuestionState: false,
  nota: 0,
  desempeño: "",
  evalFormCompetencyQuestionFalla: "",
  saveLoaderEvalFormCompetencyQuestion: false,
  evalFormCompetencyQuestionFormError:null,
};

export default function EvalFormCompetencyQuestionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_FORMULARIO_COMPETENCIA_QUESTIONS:
      return { ...state, loaderEvalFormCompetencyQuestion: action.payload };

    case actions.GET_FORMULARIO_COMPETENCIA_QUESTIONS:
      return {
        ...state,
        evalFormCompetencyQuestion: action.payload.evalFormCompetencyQuestion,
        evalFormCompetencyQuestionState:action.payload.evalFormCompetencyQuestionState,
        nota: action.payload.nota,
        desempeño: action.payload.desempeño
      };

    case actions.FORMULARIO_COMPETENCIA_QUESTIONS_FALLA:
      return { ...state, evalFormCompetencyQuestionFalla: action.payload };

    case actions.SAVE_LOADER_FORMULARIO_COMPETENCIA_QUESTIONS:
      return { ...state, saveLoaderEvalFormCompetencyQuestion: action.payload };

    case actions.FORM_FORMULARIO_COMPETENCIA_QUESTIONS_FAIL:
      return { ...state, evalFormCompetencyQuestionFormError: action.payload };
      
    default:
      return state;
  }
}
